import styled from "styled-components"

export default styled.div`
    border-top: 1px solid #ececec;
    padding: 14px 20px;
    cursor: pointer;
    flex-grow: 1;
    background-color: ${props => props.disabled ? '#f5f5f5' : '#fff'};
    ${props => props.disabled && 'color: grey'};

    .usa-link {
          ${props => props.disabled && 'color: grey'};
    }

    p {
        margin: 0;  
        // font-size: 18px;
        line-height: 28px; 
    }

    &:hover {
        background-color: ${props => props.disabled ? '#f5f5f5' : '#ececec'};
    }
`